// extracted by mini-css-extract-plugin
export default {"cardWrapper":"StatisticCard2_cardWrapper__rqOxs","card":"StatisticCard2_card__0A45G","round":"StatisticCard2_round__DUwq3","title":"StatisticCard2_title__cnODA"};